module.exports = __webpack_public_path__ + "13705250556e93242ce242ffc8270a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201605_sputnika_2.jpg
// module id = 645
// module chunks = 0